import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uploadFormData: {
    id: '',
    file: { filename: '', filepath: '' },
    starting_date: '',
    country_id: null,
  },
  filepathBlobUrl: '',
  isProgressModalOpen: false,
};

const bukuTarifSlice = createSlice({
  name: 'bukuTarif',
  initialState,
  reducers: {
    setUploadFormData(state, action) {
      state.uploadFormData = { ...state.uploadFormData, ...action.payload };
    },
    setFilepathBlobUrl(state, action) {
      state.filepathBlobUrl = action.payload;
    },
    setProgressModalOpen(state, action) {
      state.isProgressModalOpen = action.payload;
    },
    resetUploadState(state) {
      state.uploadFormData = initialState.uploadFormData;
      state.filepathBlobUrl = initialState.filepathBlobUrl;
      state.isProgressModalOpen = initialState.isProgressModalOpen;
    },
  },
});

export const {
  setUploadFormData,
  setFilepathBlobUrl,
  setProgressModalOpen,
  resetUploadState,
} = bukuTarifSlice.actions;

export default bukuTarifSlice.reducer;
